module.exports = {
  "下载":"Скачать",
  "打开":"Открыть",
  language: {
    "name":"简体中文",
    "title":"选择语言",
    subList: [
      {
        name:"English",
        link:"en",
      },
      // {
      //   name:"简体中文",
      //   link:"zh",
      // },
      {
          name:"繁體中文",
          link:"tw",
      },
      {
        name:"日本語",
        link:"jp",
      },
      {
        name:"한국어",
        link:"kr",
      },
      {
        name:"ไทย",
        link:"th",
      },
      {
        name:"Tiếng Việt",
        link:"vn",
      },
      {
        name:"Español",
        link:"es",
      },
      {
        name: 'Deutsch',
        link: 'de',
      },
      {
        name: 'Français',
        link: 'fr',
      },
      {
        name: 'Italia',
        link: 'it',
      },
      {
        name: 'Portugal',
        link: 'pt',
      },
      {
        name: 'Расея',
        link: 'ru',
      },
      {
        name: 'عربي',
        link: 'ar',
      },
    ]
  },
  "user":{//my
    "wdtd":"Моя команда",
    "wdyj":"Моя производительность",
    "ren":"человек",
  },
  "kjsy": {
    "title":"Доход",
    "fxsy":"Доля дохода",
    "zjlsl":"Общая сумма вознаграждения",
    "jl":"Награда",
    "sj":"Дата",
    "sl":"Количество",
    "sm":"Описание",
  },
  pay:{//purchase
    "title":"Купить майнинговую машину",
    "gmsl":"Количество покупки",
    "zf":"Оплата",
    "kyye":"Доступный баланс",
    "kyyebz":"Недостаточный доступный баланс",
    "bztbtips":"Введенная сумма вывода меньше минимального требования вывода этой валюты",
    "bztbtips2":"Сумма вывода не может быть меньше минимального вывода",
    "qsrjymm":"Пожалуйста, введите 6-значный пароль транзакции",
    "wxts":"Напоминание",
  },
  chongbi:{
    "title":"Депозит",
    "lianmc":"Тип цепочки",
    "scl":"Создать эксклюзивную цепочку",
    "sy":"Закрытый ключ",
    "ewm":"QR-код",
    "bcewm":"Сохраните QR-код",
    "cbdz":"Адрес депозита",
    "fz":"Копировать",
    "sl":"Сумма депозита",
    "qsrsl":"Введите сумму депозита",
    "sjczje":"Фактическая сумма пополнения",
    "qsrsjczje":"Введите фактическую сумму пополнения",
    "pzms":"Описание сертификата",
    "qsrms":"Введите описание",
    "hxz":"Хеш-значение",
    "qsrhxz":"Введите хеш-значение",
    "pztp":"Изображение ваучера",
    "qscpztp":"Загрузите изображение сертификата",
    "fzcg":"Копировать успешно",
    "yhkcz":"Пополнение банковской карты",
    "usdtcz":"Пополнение USDT",
    "btccz":"Пополнение BTC",
    "xzbz":"Выберите валюту",
    "sure":"Подтвердить",
    "ck":"Просмотр",
    "tips1":"Пожалуйста, не пополняйте активы, которые не в этой валюте, по указанному выше адресу, иначе активы не могут быть получены",
    "tips2":"1. Ваша отправляющая сеть и целевая платформа согласованы; если вы выбираете целевым адресом сеть Ethereum, вы должны выбрать соответствующую смарт-цепочку при отправке. Если будет ошибка, вы не сможете получить свои цифровые активы.",
    "tips3":"2. Убедитесь, что ваш адрес и сеть согласованы перед отправкой.",
    "tips4":"Теплое напоминание: из-за анонимности и конфиденциальности сети блокчейна, как только вы введете неверную информацию, вы потеряете соответствующие активы. Пожалуйста, обязательно дважды проверьте свой адрес доставки.",
  },
  usdttb:{
    "title":"Вывод",
    "lmc":"Тип цепочки",
    "xzl":"Выбрать цепочку",
    "xztbdz":"Выбрать адрес вывода",
    "qsrtbdz":"Введите адрес вывода",
    "tbdz":"адрес вывода",
    "qsrdz":"Введите адрес",
    "tbsl":"Сумма вывода",
    "tbsl2":"Сумма вывода",
    "qsrtbsl":"Введите сумму вывода",
    "sjtxje":"Фактическая сумма вывода",
    "qsrsjtxje":"Введите фактическую сумму вывода",
    "dzje":"Сумма счета",
    "jymm":"Пароль транзакции",
    "qsrjymm":"Введите пароль транзакции",
    "sxf":"Комиссия за обработку",
    "qsrsxf":"Введите комиссию за обработку",
    "dzsl":"Сумма счета",
    "dzsl2":"Сумма полученного счета:",
    "qsrdzsl":"Введите сумму счета",
    "wxts":"Напоминание:",
    "mrzdtxcs":"Минимальная сумма вывода каждый раз:",
    "hxxf":"Необходимо использовать",
    "cktx":"Доступно только для вывода",
    "ci":"Время",
    "wddtxyq":"Требования к выводу не выполнены",
    "tjcg":"Успешная отправка, пожалуйста, дождитесь проверки",
    "tips":"Вы можете вывести монеты, только если ваша собственная вычислительная мощность превышает 1T (за исключением вычислительной мощности опытной майнинговой машины) или вычислительная мощность под зонтиком превышает 50T.",
    "dz":"Адрес",
    "qd":"ОК",
    "zdtb":"Минимальная сумма вывода",
  },
  kefu: {
    "title":"Связаться со службой поддержки",
    "zxkf":"Служба поддержки",
    "fzcg":"Копирование выполнено успешно",
  },
  xgdlmm:{//Modify login password
    "title":"Изменить пароль для входа",
    "t1":"Текущий пароль для входа",
    "t2":"Введите текущий пароль для входа",
    "t3":"Новый пароль",
    "t4":"Введите от 6 до 16 цифр и букв",
    "t5":"Подтвердите пароль",
    "t6":"Введите от 6 до 16 цифр и букв",
    "t7":"Подтвердите",
    "t8":"Пароль не соответствует паролю подтверждения",
    "mm":"Пароль",
    "qsrmm":"Введите пароль",
    "qqrmm":"Подтвердите пароль",
    "qsrsjh":"Номер мобильного телефона",
    "zc":"Регистрация",
    "mmts":"Длина пароля 6-12 символов",
  },
  sztxmm:{//Set withdrawal password
    "title":"Изменить пароль транзакции",
    "wjtkmm":"Забыли пароль транзакции",
    "qsrjdlmm":"Введите текущий пароль транзакции",
    "zh":"Учетная запись",
    "qsryxhzsj":"Введите адрес электронной почты или номер мобильного телефона",
    "t1":"Текущий пароль транзакции",
    "t2":"Новый пароль транзакции",
    "t3":"Введите 6-значный пароль транзакции",
    "t4":"Подтвердите пароль",
    "t5":"Забыли пароль транзакции?",
    "t6":"Подтвердить",
    "t7":"Пароль не соответствует паролю подтверждения",
    "t8":"Пароль транзакции",
    "yzm":"Проверочный код",
    "qsryzm":"Введите проверочный код",
    "hqyzm":"Получить код проверки",
  },
  record: {
    "cbjl":"Запись депозита",
    "tbjl":"Запись снятия",
    "status":"['Не рассмотрено','Пройдено','Отклонено']",
    "bhly":"Причина отклонения",
    "ldz":"Адрес",
    "cjsj":"Время создания",
    "zzsj":"Время перевода",
    "czl":"Цепочка пополнения",
    "zrl":"Цепочка перевода",
    "jyhx":"Хэш транзакции",
  },
  yqm: {
    "wdyqlj":"Моя ссылка для приглашения",
    "wdyqm":"Мой код приглашения",
    "schbyq":"Сгенерировать приглашение для постера",
    "bctp":"Сохранить картинку",
    "qx":"Отмена",
    "fx":"Поделиться",
    "yqm":"Копировать код приглашения",
    "bcewmdxc":"Сохранить QR-код в альбом",
    "bcbd":"Сохранить локально",
  },
  "wdtd": {
    "title":"Моя команда",
    "td":"Команда",
    "yqhy":"Пригласить друзей",
    "ren":"Персона",
    "wdtdzrs":"Общее количество членов моей команды",
    "uid":"UID:",
    "zh":"Аккаунт:",
    "tdrs":"Размер команды:",
    "zcsj":"Дата регистрации:",
  },
  "wdyj": {
    "title":"Моя эффективность",
    "wdyd":"Мое поколение",
    "dyj":"Эффективность",
    "tdzyj":"Общая эффективность команды",
    "uid":"UID",
    "tdrs":"Размер команды:",
    "yj":"Эффективность:",
  },
  "zc": {
    "title":"Активы",
    "zzczh":"Общий эквивалент активов",
    "dh":"Обмен",
    "yczc":"Активы скрыты как 0",
    "xj":"Текущая цена",
    "zh":"Конвертировано",
    "zcmx":"Сведения об активе",
  },
  "duihuang": {
    "title":"Обмен",
    "hl":"Курс обмена",
    "zf":"Оплата",
    "qbdh":"Обмен всех",
    "ky":"Доступно",
    "dd":"Получить",
    "ljdh":"Использовать сейчас",
    "cont":"Изменение курса обмена в зависимости от фактической полученной суммы",
    "yebz":"Недостаточный баланс",
    "ksslbz":"Недостаточное количество доступных",
    "qtxje":"Введите количество",
    "dhcg":"Обмен успешен",
    "mrcg":"Купить успешно",
    "mccg":"Успешно продано",
    "wtcg":"Делегирование успешно",
    "ts":"Prompt",
    "btcmTips":"Согласно настройкам смарт-контракта, обмен GDCC USDT начнется 8 августа 2023 года.",
    "qx":"Отмена",
  },
  "sign": {
    "title":"Войдите, чтобы получить монеты",
    "title2":"Ежедневное вознаграждение за вход",
    "title3":"Награда за вход",
    "qd":"Войти",
    "yqd":"Войти",
    "hdgz":"Детали правила",
    "qdjl":"Запись о регистрации",
    "qdcg":"Войти успешно",
  },
  "langNew": {
    "wd":"Мои",
    "jd":"Заимствование",
    "jghy":"Фьючерсы",
    "xbsg":"Покупка валюты Сингапура",
    "sylx":"Тип выгоды",
    "syts":"Дни заработка",
    "rsy":"Ежедневный доход",
    "rsy2":"Ежедневный доход",
    "yjdts":"Количество дней займа",
    "jdsy":"Доход от кредитования",
    "jdsy2":"Доход от кредитования",
    "jdrq":"Дата кредита",
    "qdsy":"Вход Преимущества",
    "tgsy":"Преимущество по акции",
    "sybl":"Коэффициент прибыли",
    "sybl2":"Коэффициент прибыли",
    "ljcy":"Присоединиться сейчас",
    "zsy":"Общий доход USDT",
    "jdrz":"Узел ссылки",
    "jiedian":"узел",
    "qsrje":"Пожалуйста, введите узел",
    "xyb":"Далее",
    "zhye":"Баланс счета",
    "dzye":"Баланс адреса",
    "zhyezh":"Баланс счета (эквивалент)",
    "zq":"Период:",
    "zq2":"период",
    "jdsl":"Сумма кредита",
    "yxbd":"Подтверждение адреса электронной почты",
    "qsryxzh":"Пожалуйста, введите свой адрес электронной почты",
    "yxgz":"Введенный адрес электронной почты не соответствует правилам",
    "jxz":"В процессе",
    "ywc":"Завершено",
    "day":"Дней",
    "jg":"Цена",
    "zwsj":"Нет данных~",
    "wyjb":"Занять",
    "fxjl":"Поделиться вознаграждением",
    "aqsz":"Настройки безопасности",
    "wded":"Мое второе поколение",
    "wdsd":"Мои три поколения",
    "dbxe":"Лимит единовременной транзакции",
    "tjdd":"Отправить заказ",
    "tqsh":"Вывод Выкуп",
    "shuhui":"Выкуп",
    "ljdz":"Адрес ссылки",
    "yyqh":"Переключение языка",
    "zxkf":"Обслуживание клиентов",
    "syl":"Ежедневный возврат",
    "zhuanbi":"Заработать монеты",
    "zbsy":"Заработать валютный доход",
    "mc":"Имя",
    "zxj":"Последняя цена",
    "zfb":"Растущий список",
    "shouye":"Главная страница",
    "gg":"Объявление",
    "rzz":"Сертификация",
    "yrz":"Аутентификация выполнена",
    "rzsb":"Аутентификация не удалась, пожалуйста, повторите аутентификацию",
    "cxrz":"Повторная аутентификация",
    "jymmts":"Пожалуйста, установите пароль транзакции",
  },
  "xbsg":{
    "title":"Newcoin",
    "wdsg":"Подробности",
    "scts":"Дни блокировки:",
    "sy":"Осталось",
    "ljsg":"Подписаться сейчас",
    "ysk":"Продано",
    "xzjdy":"Подписаться сейчас",
    "dy":"Подписаться",
    "fxjg":"Цена выпуска",
    "fxl":"Тираж",
    "ssrq":"Дата листинга",
    "yxqx":"Срок действия",
    "qsrsl":"Пожалуйста, введите сумму",
    "syl":"Осталось",
    "sgrq":"Подписаться",
    "sgsl":"Сумма",
    "bz":"Монета",
    "yebz":"Недостаточный баланс USDT",
    "tgsl":"Кол-во сдачи",
    "shz":"На рассмотрении",
    "wtg":"Не сдан",
    "ytg":"Сдан",
  },
  "wydb":{
    "title":"Занять",
    "db":"Занять",
    "dbz":"Записать",
    "jl":"Период (дней)",
    "jdzq":"Для погашения",
    "qhk":"Накопительный(usdt)",
    "ljdb":"Ожидаемый платеж",
    "dhkbs" :"Сумма кредита(usdt)",
    "jkje":"Введите сумму",
    "qsrje":"Ежедневная процентная ставка",
    "rll":"Погашение",
    "hkfs":"Истек",
    "dqych":"Просроченный",
    "lx":"Проценты",
    "fkjg":"Кредитор",
    "tpsc":"Кредитный заем (загрузка изображения)",
    "fwxx":"Информация о жилье",
    "srzm":"Подтверждение дохода (трудовые отношения)",
    "yhmx":"Выписка из банка",
    "zjz":"Фото удостоверения личности",
    "yd":"Я прочитал и согласен",
    "xy":"Подать заявку на кредитное соглашение",
    "sqdb":"Нажмите, чтобы подать заявку на цепочки кредитов",
    "gb":"Закрыть",
    "qd":"ОК",
    "ts":"Пожалуйста, проверьте Подать заявку на кредитное соглашение",
    "dbjl":"Запись",
    "hkhth":"Код заказа",
    "wsh":"Непросмотренный",
    "yfk":"Кредит",
    "sqrq":"Время подачи заявки",
    "zq":"Цикл",
    "dbsl":"Количество ребер",
    "zhke":"Общая сумма платежа",
    "yhkxq":"Сведения о погашении",
    "bqyhk":"Кредит к погашению в текущем периоде (USDT)",
    "hktips":"Убедитесь, что баланс достаточен, если баланс недостаточен, сначала пополните счет, а затем погасите",
    "bj":"Основной долг",
    "jie":"Занять",
    "ljhk":"Погасить немедленно",
    "qcz":"Для внесения депозита",
    "yebzqxcz":"Недостаточный баланс, сначала пополните счет, а затем погасите",
    "znj":"Плата за просрочку платежа",
    "yqts":"Дни просрочки",
  },
  "hkxq":{
    "dd":"Заказ",
    "fzhkdz":"Скопируйте адрес погашения",
    "hkxq":"Детали погашения",
    "zlx":"Общая сумма процентов",
    "zhk":"Общая сумма погашения",
    "hkjg":"Агентство по погашению",
    "qschkpz":"Загрузите сертификат погашения",
    "hkpz":"Сертификат погашения",
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"Заказ",
    "cj":"Сделка",
    "jj":"Информация",
    "sj":"Время",
    "fx":"Направление",
    "jg":"Цена",
    "sl":"Количество",
    "mr":"Купить",
    "mc":"Продать",
    "mp":"Ставка",
    "sp":"Продажа",
    "slb":"Кол-во",
    "fhsj":"Дата выпуска",
    "fhsl":"Номер выпуска",
    "bps":"Белая книга",
    "gw":"Официальный сайт",
    "fz":"мин",
    "xs":"час",
    "tian":"дни",
    "zhou":"неделя",
    "yue":"месяц",
    "gd":"Еще",
    "ft":"Подграф",
    "zt":"Основной график",
    "sdt":"Глубина изображения",
    "zx":"Избранное",
    "djck":"Нажмите для просмотра",
  },
  "jghy":{
    "jghy":"Параметры",
    "yxhy":"Бессрочный",
    "mz":"Купить лонг",
    "md":"Купить шорт",
    "gmj":"Цена покупки",
    "jsj":"Цена расчета",
    "xj":"Текущая цена",
    "fx":"Направление",
    "sl":"Объем",
    "jgsj":"Время доставки",
    "gb":"Закрыть",
    "jxxd":"Продолжить размещение заказа",
    "cclb":"Список заказов",
    "zc":"Текущий",
    "lscc":"История",
    "qblx":"Все",
    "yk":"Прибыль",
    "ddqr":"Подтверждение заказа",
    "dqsj":"Время истечения срока",
    "jssj":"Время доставки",
    "sy":"Прибыль",
    "tzje":"Цена инвестиции",
    "zdje":"Самая низкая цена 0",
    "kyye":"Баланс",
    "kyye2":"Баланс",
    "sxf":"Комиссия:",
    "sxfl":"Комиссия",
    "jypz":"Название",
    "jyfx":"Направление",
    "qrxd":"Подтвердить",
    "fs":"Линия",
    "dqye":"Текущий баланс",
  },
  "zhjl":{
    "title":"История активов",
    "cbtb":"Депозит и снятие",
    "jymx":"История транзакций",
    "tgyj":"Комиссия по продвижению",
    "wwc":"Отменено",
    "ywc":"Завершено",
  },
  "tipsNew":{
    "wjmmts":"Восстановить пароль по проверочному коду",
    "qscpztp":"Пожалуйста, загрузите изображение ваучера",
    "emailgsts":"Вводимые почтовые ящики не соответствуют правилам",
    "telgsts":"Неверный номер мобильного телефона",
    "lcmmbyz":"Пожалуйста, подтвердите свой пароль",
    "zdsl":"Мин. кол-во",
    "sldydy":"Количество больше или равно",
    "zxtzsl":"Мин. кол-во",
    "ddz":"Ожидание",
    "xs":"Час",
    "min":"Минимальная сумма",
    "max":"Максимальная сумма",
    "yebz":"Недостаточный баланс",
    "qsrss":"Введите количество лотов",
    "zdss":"Минимальное количество лотов",
    "yjj":"Отклонено",
    "shz":"Выкуп",
    "zwkfcz":"Эта валюта не открыта для депозита",
    "jiaoge":"Доставка",
    "zhang":"Длинная",
    "die":"Короткая",
  },
  "assets": {
    "total":"Конвертация активов (USD)",
    "avaiable":"Доступно",
    "conversion":"Конвертация",
    "canuse":"Доступно",
    "yczc":"Активы скрыты как 0",
  },
  "status": {
    "statusText":"['failure','waiting','success']",
  },
  "langNew2":{
    "zczgz":"Всего активов",
    "hgx":"Соответствие",
    "yszc":"Политика конфиденциальности",
    "gywm":"О нас",
    "zb":"Арбитраж ИИ",
    "mnjy":"Имитационная торговля",
    "xbzq":"Валютная зона Сингапура",
    "flzq":"Rewards Hub",
    "cjmnzhcg":"Создайте демо-счет успешно!",
    "wdzh":"Мой счет",
    "yymnzhts":"Уже есть виртуальный счет, пожалуйста, не регистрируйтесь снова",
    "tcmnzh":"Выйти из демо-счета",
    "mnzhgz":"Оценка демо-счета",
    "mnzh":"Демонстрационный счет",
    "ljdzsb":"Не удалось подключиться к адресу",
    "ysq":"Авторизованный",
  },
  "c2c":{
    "bt":"C2C",
    "bt2":"C2C Payment Service",
    "cjdd":"Создать заказ",
    "mblc":"Депозит в фиатной валюте",
    "cjydd":"Создать предварительный заказ",
    "xmjfk":"Оплатить продавцу",
    "tqhb":"Вывести свою цифровую валюту",
    "ddzt":"Статус заказа",
    "wdys":"Наши преимущества",
    "c1":"Торгуйте по предпочитаемой вами цене",
    "c2":"Свободно покупайте и продавайте криптовалюты по предпочитаемой вами цене. Покупайте и продавайте по существующим предложениям или создайте торговое объявление, чтобы установить идеальную для вас цену.",
    "c3":"Низкая комиссия за транзакцию",
    "c4":"Транзакции Peer-to-Peer (C2C) позволяют продавцам свободно определять желаемый ими способ оплаты прозрачным образом, покупая и продавая криптовалюты с помощью более чем 700 способов оплаты, включая банковский перевод и наличные.",
    "c5":"Множественные способы оплаты",
    "c6":"Торговля Peer-to-Peer (C2C) позволяет продавцам свободно определять желаемый ими способ оплаты. Покупайте и продавайте криптовалюты с помощью более чем 700 способов оплаты, включая банковские переводы и наличные.",
    "wpp":"Не совпадает",
    "ypp":"Совпадает",
    "ysx":"Истек",
    "ddh":"Номер заказа",
    "mrje":"Сумма покупки",
    "mrbz":"Валюта покупки",
    "nssdgj":"Страна",
    "qsrnssdgj":"Укажите страну",
    "fkrxm":"Имя плательщика",
    "qsrfkrxm":"Введите имя плательщика",
    "yx":"Электронная почта",
    "qsryx":"Введите свой адрес электронной почты",
    "mmbz":"Тип покупки",
    "qxzmmbz":"Выберите тип покупки",
    "qxz":"Выберите",
    "fkfs":"Способ оплаты",
    "qtxfkfs":"Укажите способ оплаты",
    "zh":"Счет",
    "fb":"Тип валюты платежа",
    "qtxfb":"Укажите тип валюты платежа",
    "ngmdje":"Сумма покупки",
    "qsrje":"Введите сумму",
    "wxts":"Теплое напоминание",
    "dsh":"Ожидаю проверки",
    "ygq":"Истек",
    "jcwdwt":"Введение в C2C",
    "tjpz":"Отправить ваучер",
    "ckje":"Сопоставление суммы",
    "qsrckje":"Введите сопоставляемую сумму",
    "tjzzfb":"Копия перевода",
    "tjjzzm":"Удостоверение личности (лицевая сторона)",
    "tjjzfm":"Удостоверение личности (обратная сторона)",
    "psts1":"При съемке обратите внимание на следующие моменты",
    "psts2":"Обратите внимание, что граница снимка должна быть полной, шрифт — четким, а яркость — равномерной",
    "psts3":"Не загружайте фотографии удостоверений личности, на которых ваше имя не совпадает",
    "qsczzfb":"Загрузите копию перевода",
    "qscjzzm":"Загрузите лицевую сторону водительских прав",
    "qscjzfm":"Загрузите обратную сторону водительских прав",
    "tj":"Отправить",
    "je":"Ограничить диапазон",
    "ljtg":"Оформить заказ",
    "sp":"Понять DEFI",
    "xq":"Подробности",
    "lxkfppdd":"Связаться со службой поддержки клиентов, чтобы сопоставить заказ",
    "szgj":"Страна",
    "qsrszgj":"Пожалуйста, введите свою страну",
    "fkyhmc":"Название платежного банка",
    "qsrfkyhmc":"Пожалуйста, введите название платежного банка",
    "dianhui":"Банковский перевод/Международный банковский перевод",
    "ccsr":"Введите здесь",
  },
  "xyf":{
    "title":"Кредитный рейтинг",
    "pgsj":"Время оценки",
  },
  "bbjy":{
    "mr":"Купить",
    "mc":"Продать",
    "mai":"Покупка",
    "sell":"Продать",
    "xj":"Лимит",
    "sj":"Рынок",
    "pk":"Позиция",
    "jg":"Цена",
    "sl":"Кол-во",
    "ss":"Количество",
    "mrl":"Объем покупки",
    "mcl":"Объем продажи",
    "ky":"Доступно",
    "km":"Доступно",
    "ksell":"Торговый",
    "jye":"Оборот",
    "dqwt":"Текущее доверие",
    "lswt":"Историческое доверие",
    "jj":"Информация",
    "wtzl":"Итого",
    "wtjg":"Цена доверительного управления",
    "ycjl":"Завершенный объем торгов",
    "cjjj":"Средняя цена транзакции",
    "cd":"Отменить заказ",
    "xd":"Завершенная сделка",
    "wqcj":"Завершен",
    "ywc":"Отмененный заказ",
    "ycd":"Избранное",
    "zx":"Рыночная цена",
    "scjg":"Дата выпуска",
    "fhsj":"Номер выпуска",
    "fhsl":"Белая книга",
    "bps":"Официальный сайт",
    "gw":"Отмена",
    "qx":"Обмен",
    "bbjy":"Покупка",
  },
  "hyjy":{
    "mai":"Продажа",
    "sell":"Открытые позиции",
    "kc":"Закрыть позиции",
    "pc":"Позиции",
    "cc":"Закрыть",
    "kp":"Закрыть короткие",
    "kpc":"Позиции",
    "kcc":"Открыть длинную",
    "kkd":"Закрыть длинную",
    "kpd":"Открыть короткую",
    "kkk":"Лимитный",
    "xj":"Рыночная",
    "sj":"Лимитный",
    "xjwt":"Лимитный заказ",
    "sjwt":"Рыночная цена",
    "pk":"Позиция",
    "jg":"Цена",
    "sl":"Кол-во",
    "gg":"Рычаг",
    "tzgg":"Рычаг управления",
    "ggbs":"Кредитное плечо",
    "mrl":"Объем покупки",
    "ky":"Доступно",
    "jye":"Оборот",
    "dqwt":"Текущие вложения",
    "lswt":"Историческое вложение",
    "ptwt":"Обычные вложения",
    "dqwtmr":"Текущие вложения (Купить)",
    "dqwtmc":"Текущие вложения (Продать)",
    "hywt":"Контрактные вложения",
    "jj":"Информация",
    "wtzl":"Итого",
    "wtjg":"Цена вложения",
    "ycjl":"Завершенный объем торгов",
    "cjjj":"Средняя цена транзакции",
    "qbcd":"Снять все ордера",
    "cd":"Отменить ордер",
    "xd":"Ордер",
    "wqcj":"Завершенная сделка",
    "ywc":"Завершен",
    "ycd":"Отмененный ордер",
    "zx":"Избранное",
    "scjg":"Рыночная цена",
    "fhsj":"Дата выпуска",
    "fhsl":"Номер выпуска",
    "bps":"Белая книга",
    "gw":"Официальный сайт",
    "mrzd":"Длинное открытие",
    "mrpk":"Короткое закрытие",
    "mczk":"Короткое открытие",
    "mcpd":"Длинное закрытие",
    "mrkdkz":"Длинное открытие (бычье)",
    "mrpkkz":"Короткое закрытие (бычье)",
    "mckkkd":"Короткое открытие (медвежье)",
    "mcpdkd":"Длинное закрытие (медвежье)",
    "yxhy":"Бессрочный контракт",
    "dc":"Длинные позиции",
    "kcjj":"Средняя цена открытой позиции (BUSDT)",
    "wsxyl":"Нереализованная прибыль (BUSDT)",
    "ygqpj":"Оценка сильной паритет(BUSDT)",
    "syl":"Ежедневный доход",
    "cwbzj":"Маржа позиции(BUSDT)",
    "cw":"Позиции (кол-во)",
    "cwjz":"Стоимость позиции(BUSDT)",
    "bzjl":"Ставка маржи",
    "kpz":"Закрытие (кол-во)",
    "bdzs":"Базовый индекс",
    "tzbzj":"Отрегулируйте маржу",
    "zyzs":"Тейк-профит и стоп-лосс",
    "zjbzj":"Увеличьте маржу",
    "jsbzj":"Уменьшите маржу",
    "tyhy":"Контракт опыта",
    "ccz":"Позиция (№)",
    "cwbzjt":"Маржа позиции (TBTC)",
    "zdzjbzj":"Максимальное увеличение маржи (TBTC)",
    "zjbzjt":"Увеличение маржи (TBTC)",
    "zhang":"Количество",
    "qblx":"Все типы",
    "qb":"Все",
    "ccjg":"Цена позиций",
    "ccsl":"Количество позиций",
    "yk":"Прибыль и убыток",
    "ccsj":"Время позиций",
    "zy":"Тейк-профит",
    "zs":"Стоп-лосс",
    "zje":"Общая сумма",
    "kcs":"Количество открытых позиций",
    "kcjg":"Цена открытых позиций",
    "ss":"Лоты",
    "hand":"1 лот =",
    "qx":"Отмена",
    "qr":"ОК",
  },
  "bbjyNew":{
    "jylx":"Типы",
    "jyze":"Сумма",
  },
  "langNew3":{
    "bzxq":"Подробности о перемещении кирпичей",
    "znbz":"Количественное интеллектуальное перемещение кирпичей ИИ",
    "apits":"Бесшовное подключение к API более 200 бирж по всему миру",
    "jr":"Присоединиться",
    "gn":"Функция",
    "lhjs":"Введение в количественную оценку дивидендов",
    "jqrts":"Как работают роботы?",
    "sctj":"Статистика рынка",
    "scqk":"Конъюнктура рынка",
    "jiaoge":"Доставка",
    "zhang":"Рост",
    "die":"Падение",
    "sz":"Настройки",
    "qbcp":"Все продукты",
    "jrlh":"Присоединиться к количественной оценке AI",
    "sywd":"0 риска, стабильная доходность",
    "bzbz":"Тип криптовалюты",
  },
  "sztkmm":{
    "title":"Установить пароль для вывода",
    "dlmm":"Пароль для входа",
    "dlmmts":"Пожалуйста, введите пароль для входа",
    "xmm":"Новый пароль",
    "mmts":"Длина пароля 6 цифр",
    "qrmm":"Подтвердите пароль",
    "qr":"ОК",
    "qd":"ОК",
    "sztkts":"Совет: перейдите в Центр безопасности, чтобы установить пароль транзакции",
  },
  "bzhl":{
    "title":"Дивиденды",
    "gz":"Правила",
    "tgdd":"Условный депонированный заказ",
    "zztgdzj":"Средства на хранении",
    "yjjrsy":"Предполагаемый ежедневный",
    "ljsy":"Общий доход",
    "tgzdd":"Заказ на хранении",
    "cljxcp":"Продукты стратегической кампании",
    "dbxe":"Лимит",
    "rsyl":"Ежедневная норма прибыли",
    "zq":"Цикл заказа",
    "qmr":"Перейти и купить",
    "bbzhzc":"Активы счета",
    "zcc":"Общие активы (USDT)",
    "dd":"Заказы",
    "buy":"Купить в",
    "jxcp":"Избранные продукты",
    "ckdd":"Проверить заказ",
    "gd":"Еще",
    "xzbzts":"Просто и безопасно. Дивиденды можно выбрать в нескольких валютах",
    "qtbz":"Другие монеты",
    "dj":"Уровень",
    "cjwt":"Распространенные проблемы",
    "ddsl":"Количество заказов",
    "sl":"Сумма",
  },
  "bzhlgm":{
    "title":"Прибыль от удаления кирпича",
    "bzhld":"Прибыль от удаления кирпича USDT",
    "qtzq":"USDT 7-дневный цикл",
    "rsyl":"Ежедневная ставка доходности",
    "lczq":"Финансовый цикл",
    "dbxe":"Лимит",
    "pxsj":"Срок выплаты дивидендов",
    "mr":"Ежедневно",
    "dqfh":"Возврат по истечении срока",
    "tgzj":"Капитал для хранения",
    "tqsh":"Досрочное погашение",
    "yjsy":"Ожидаемый доход (USDT)",
    "kyzc":"Доступные активы (USDT)",
    "cpjs":"О наших продуктах",
    "tgje":"Введите сумму",
    "qsrtgje":"Пожалуйста, введите сумму для хранения",
    "qb":"Все",
    "rm":"Нажмите здесь",
    "cpzq":"Цикл продукта",
    "jxr":"Дата расчета процентов",
    "jiexr":"Дата расчета процентов",
    "yjdzr":"Предполагаемая дата прибытия",
    "gz":"Знать правила и проценты",
  },
  "bzhlwdtg":{
    "title":"Статус заказа",
    "tgz":"На хранении",
    "ywc":"Завершено",
    "ysh":"Погашено",
    "tgje":"Сумма хранения/Время хранения",
    "rsyl":"Ежедневная ставка возврата",
    "yhl":"Прибыль",
    "xdsj":"Время заказа",
    "sh":"Погашение",
    "ddxq":"Детали заказа",
    "ddh":"Номер заказа",
    "syts":"Осталось",
    "ddztxq":"Детали статуса заказа",
  },
  "langNew4":{
    "kp":"Открытие",
    "zuoshou":"Получено вчера",
    "zg":"Самый высокий",
    "zd":"Самый низкий",
    "dqjg":"Текущая цена",
    "pcjg":"Цена закрытия",
    "gd":"Отложенный ордер",
    "gdj":"Цена отложенного ордера",
    "gdjg":"Цена отложенного ордера",
    "xfbzj":"Требуется залог",
    "ksrfw":"Доступный диапазон ввода",
    "shou":"Лоты",
    "fdjyk":"Плавающая чистая прибыль и убыток",
    "pcsl":"Закрывающее количество",
    "cx":"отозвать",
    "qrpc":"Подтвердите закрытие позиции",
    "sx":"Фильтр",
    "cz":"Сброс",
    "zdl":"Знал",
    "kccg":"Успешно открыл позицию!",
    "xzfx":"Выберите направление",
    "lx":"Тип",
    "xgcc":"Изменить позицию",
    "szzyzs":"Установить стоп-профит и стоп-лосс",
    "szhb":"Крипто",
    "gjs":"Металл",
    "yy":"Сырая нефть",
    "jy":"Торговля",
    "jmhb":"Крипто",
    "gdsj":"Время отложенного ордера",
    "gdsl":"Количество отложенных ордеров",
    "fs":"Время",
   },
   "deals": {
  	"issue_time":"Время",
    "issue_number":"Число",
    "white_book":"Книга",
    "weburl":"URL",
    "video_url":"Видео",
    "introduction":"Информация",
    "onhand":"одна рука равна",
    "position":"Позиция",
    "leverorder":"Кредитные ордера",
    "leverposition":"кредитная позиция",
    "inputprice":"Входная цена",
    "inputmul":"Входной множественный",
    "selectmul":"Выберите множественный",
    "onehand":"одна рука равна",
    "hand":"Количество торговых рук",
    "marketval":"Рыночная стоимость",
    "bond":"Облигация",
    "service":"плата за обслуживание",
    "balance":"баланс",
    "type":"Тип",
    "risk":"Ставка риска",
    "total":"общая прибыль",
    "onekey":"закрытие его",
    "makemore":"(Длинный)",
    "makeless":"(Короткий)",
    "current":"Открытые ордера",
    "all":"Все",
    "weing":"В комиссии",
    "tding":"Торговля",
    "ping":"Закрытие",
    "pied":"Закрыто",
    "ceiled":"снято",
    "weprice":"цена комиссии",
    "oprice":"Цена открытия",
    "nowprice":"Текущая цена",
    "zyprice":"Цена стоп-прибыли",
    "zsprice":"Цена стоп-лосса",
    "canbond":"Доступная маржа",
    "optime":"Время открытия",
    "pgtime":"Время закрытия",
    "znum":"Конвертированное количество",
    "gprice":"Сборы за перенос позиции на следующий день",
    "pcang":"Закрыть",
    "revoke":"Снятие",
    "fee":"Комиссия",
    "you":"Оптимальная рыночная цена",
  },
  "zyzs":{
    "title":"Тейк-профит и стоп-лосс",
    "zy":"Тейк-профит",
    "zs":"Stop loss",
    "qsrzyjg":"Введите цену Take Profit",
    "qsrzsjg":"Введите цену Stop loss",
    "cfjglx":"Тип цены срабатывания",
    "zsjg":"Индексная цена",
    "scjg":"Рыночная цена",
    "pcfs":"Способы закрытия позиций",
    "kpcw":"Закрытие",
    "qbcw":"Все позиции",
    "wxts":"Обратите внимание",
    "cont":"Закрытие позиций по рыночной цене может привести к невозможности разместить ордер по рыночной цене или успешно зафиксировать прибыль/стоп-лосс из-за резких колебаний рынка и других проблем.",
    "qr":"ОК",
  },
  "level1": {
    "name":"Настоящее имя",
    "idcard":"Тип сертификата",
    "address":"Текущий адрес проживания",
    "bank_number":"Номер банка",
    "wc":"ОК",
    "name_nodata":"Имя не может быть пустым",
    "id_card_nodata":"Номер сертификата не может быть пустым",
    "address_nodata":"Адрес не может быть пустым",
    "bank_number_nodata":"Номер банковской карты не может быть пустым",
    "input-username":"Пожалуйста, введите свое настоящее имя",
    "zjhm":"Номер сертификата",
    "input-idcard":"Пожалуйста, введите свой номер сертификата",
    "input-address":"Пожалуйста, введите свой адрес",
    "zjlx":"Типы действительных удостоверений личности",
    "qxzzjlx":"Пожалуйста, выберите типы действительных удостоверений личности",
    "sfz":"Удостоверение личности",
    "hz":"Паспорт",
    "jsz":"Водительские права",
    "lxz":"Сертификат для обучения за рубежом",
    "zfbzh":"Счет Alipay",
    "qsrzfbzh":"Пожалуйста, введите свой счет Alipay",
    "khh":"Открытие счета",
    "qsrkhh":"Пожалуйста, введите свой банк",
    "yhkh":"Номер банковской карты",
    "qsryhkh":"Введите номер банковской карты",
    "zfzh":"Платежный счет",
    "qxzzfzh":"Выберите платежный счет",
    "gjlb":"Список стран",
    "qxzgjlb":"Выберите страну/регион",
    "gjhdq":"Страна/регион",
    "qtxgj":"Укажите страну/регион",
  },
  "gjrz":{
    "title":"Аутентификация KYC",
    "t1":"1. Поддерживаются изображения размером менее 8 МБ в форматах JPG, JPEG или PNG.",
    "t2":"2. Фотографии документов, удостоверяющих личность, должны быть четкими и не должны изменяться или блокироваться. Персональная фотография, номер документа и имя владельца документа должны быть четко видны.",
    "t3":"3. Фотографии должны быть сделаны без головного убора и не рекомендуется использовать макияж. Черты лица владельца документа должны быть четкими и узнаваемыми, а его руки должны быть полностью открыты.",
    "t4":"ОК",
    "bh":"Отклонить",
    "shz":"На рассмотрении",
    "shtg":"Одобрено",
    "nyrzcg":"Вы успешно прошли сертификацию",
    "sczjz":"Загрузить фотографии удостоверения личности",
    "sczjzmz":"Загрузить фотографию лицевой стороны удостоверения личности",
    "sczjbmz":"Загрузить фотографию оборотной стороны удостоверения личности",
    "scgrqmz":"Загрузить документы и личную подпись",
    "wdtjr":"Мой рекомендатель",
    "tjrid":"ID рекомендателя",
    "qsrtjrid":"Введите идентификатор рекомендателя",
    "idbcz":"ID реферера не существует",
    "tjcg":"Отправка выполнена успешно",
    "tjridts":"ID рекомендателя не может быть заполнен вами",
    "qsrzh":"Введите учетную запись",
    "dl":"Войти",
    "jc":"Плохо",
    "yb":"Общее",
    "yx":"Отлично",
    "ldjsqh":"Фьючерсы LME",
    "wh":"Иностранная валюта",
  },
  "newReg":{
    "sjh":"Мобильный",
    "yx":"Электронная почта",
    "yqm":"Код приглашения",
    "yqm2":"Код приглашения (необязательно)",
    "cjzh":"Создать учетную запись",
    "sysjhzyx":"Зарегистрироваться с помощью номера мобильного телефона/адреса электронной почты",
    "sj":"Мобильный",
    "yhxy":"<Пользовательское соглашение>",
    "yhxy2":"Я прочитал и согласен с  и  <Пользовательское соглашение>",
    "hmyzh":"Еще нет учетной записи?",
    "qzc":"Зарегистрироваться",
    "qbdl":"Войти в кошелек",
    "qyqbfw":"Используйте приложение кошелька для доступа",
    "dc":"Выйти",
    "cycs":"Количество участий"
  },
}



// WEBPACK FOOTER //
// ./src/utils/lang/ru.js